import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import useGetIDProviders from '../../../../hooks/use-getidproviders';
import { PROVIDER_NAMES, providers } from '../../data-layer/constants';
import {
  type IDPConfig,
  type IDPConfigKosmos,
  type ProviderResponse,
} from '../../data-layer/types';
import { OneKosmos, SaviyntIDV } from '../Providers';
import IDDataWebSettings from '../Providers/IDDataweb/IDDataweb';

function ProviderSettings() {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const id = query.get('id');

  const history = useHistory();
  const [currentProvider, setCurrentProvider] = useState<ProviderResponse>();
  const { data: idpProviders, refetch } = useGetIDProviders();

  useEffect(() => {
    setCurrentProvider(idpProviders?.find((obj) => obj.vendorName === id));
  }, [idpProviders, id]);

  const provider = providers.find((obj) => obj.vendorName === id);

  const refetchIDPProviders = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    refetch();
  };

  return (
    <>
      {id === PROVIDER_NAMES.IDDATAWEB ? (
        <IDDataWebSettings
          isOpen
          onClose={() => {
            history.push({ pathname: '/providers' });
          }}
          provider={providers.find((prov) => prov.id === id)}
          currentProvider={currentProvider as IDPConfig}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          refetchIDPProviders={refetchIDPProviders}
          setShowSuccessBanner={() => {}}
        />
      ) : (
        ''
      )}
      {id === PROVIDER_NAMES['1KOSMOS'] ? (
        <OneKosmos
          isOpen
          onClose={() => {
            history.push({ pathname: '/providers' });
          }}
          provider={providers.find((prov) => prov.id === id)}
          currentProvider={currentProvider as IDPConfigKosmos}
          currentVendor={provider}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          refetchIDPProviders={refetchIDPProviders}
          setShowSuccessBanner={() => {}}
        />
      ) : (
        ''
      )}
      {id === PROVIDER_NAMES.SAVIYNT ? (
        <SaviyntIDV
          isOpen
          onClose={() => {
            history.push({ pathname: '/providers' });
          }}
          provider={providers.find((prov) => prov.id === id)}
          currentProvider={currentProvider as IDPConfigKosmos}
          currentVendor={provider}
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          refetchIDPProviders={refetchIDPProviders}
          setShowSuccessBanner={() => {}}
        />
      ) : (
        ''
      )}
    </>
  );
}

export default ProviderSettings;
